module.exports = __WEBPACK_EXTERNAL_MODULE_40__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"jquery","commonjs2":"jquery","amd":"jquery","root":"$"}
// module id = 40
// module chunks = 0